// If consents are present and populated, the user is authenticated and has recorded preferences.
// If consents are present but empty, the user is authenticated and has no preferences in the system.
// If consents are not present in the DB, the user is unauthenticated and has no preferences in the system.
// currentLocale will always be present if available ("UNKNOWN" if not), regardless of auth status
// localeWhenConsented will never be relevant for unauthenticated users.
// Typical locale format: <countryCode>-<subdivisionCode> e.g. 'FR-ARA' for France, or 'US-VA' for Virginia
// There are ~30m users who do not have the modern version of their locale stored in ConsentHub (inclusive of the subdivision)
// which means we need to account for instances where we ONLY have the country code of US.

// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH

// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH

export var ConsentHubKey = /*#__PURE__*/function (ConsentHubKey) {
  ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
  ConsentHubKey["Functional"] = "functionalCookies";
  ConsentHubKey["Analytics"] = "performanceCookies";
  ConsentHubKey["Marketing"] = "targetingCookies";
  ConsentHubKey["Unknown"] = "unknownCookies";
  return ConsentHubKey;
}({});